import React from "react";
import {Grid, Typography} from "@mui/material";
import {lxStyled} from "@lxo-blocks/react";

const PREFIX = 'ErrorBanner';
const classes = {
    errorBanner: `${PREFIX}-errorBanner`,
    headline: `${PREFIX}-headline`,
    description: `${PREFIX}-description`
}
const ErrorBannerContainer = lxStyled(Grid)(({theme}) => ({
    [`.${classes.errorBanner}`]: {
        backgroundColor: `rgba(224, 55, 48, 0.1)`,
        width: "100%"
    },
    [`.${classes.headline}`]: {
        color: `${theme.palette.error.main}`,
        fontWeight: `bold`
    },
    [`.${classes.description}`]: {
        color: `${theme.palette.error.main}`,
    }
}));

export interface ErrorBannerProps {
    headline?: string;
    description?: string;
    sx?: any;
}

export default function ErrorBanner(props: ErrorBannerProps) {
    return <ErrorBannerContainer container
                                 sx={props.sx}>
        <Grid className={`${classes.errorBanner}`} sx={{p: 2}} item>
            <Typography className={`${classes.headline}`} component="div" variant="body1">{props.headline}</Typography>
            <Typography className={`${classes.description}`} component="div" variant="body2">{props.description}</Typography>
        </Grid>
    </ErrorBannerContainer>
}